
import { Vue, Component } from 'vue-property-decorator'
import EntryMobile from './EntryMobile.vue'
import EntryConsole from './EntryConsole.vue'
import { checkFrom } from '@/plugins/analyse'

@Component({
  components: {
    EntryMobile,
    EntryConsole
  }
})
export default class Landing extends Vue {
  created (): void {
    checkFrom()
  }
}
